import { Component } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent {
	title = "app";
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/app.component.ts